export enum MessageType {
  Message = 'MESSAGE',
  Status = 'STATUS',
  Unknown = 'UNKNOWN',
}
